import { render, staticRenderFns } from "./RepairsDetail.vue?vue&type=template&id=2c496589"
import script from "./RepairsDetail.vue?vue&type=script&lang=ts"
export * from "./RepairsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports